import axiosInstance from './axios';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import { BrandGetAllResponseT } from '../types/brandTypes';
import { PostDataT } from '../types/commonTypes';

export const useAddBrand = () => {
  return useMutation({
    mutationKey: ['useAddBrand'],
    mutationFn: async (postData: {
      imageUrl: string;
      brandName: string;
      description: string;
    }) => {
      const { data } = await axiosInstance.post('/brands', postData);
      return data;
    },
  });
};

export const useEditBrand = () => {
  return useMutation({
    mutationKey: ['useEditBrand'],
    mutationFn: async (postData: {
      id: string;
      imageUrl: string;
      brandName: string;
      description: string;
    }) => {
      const { data } = await axiosInstance.put('/brands', postData);
      return data;
    },
  });
};

export const useGetAllBrand = (postData: {
  pageNo: number;
  pageSize: number;
}) => {
  return useQuery({
    queryKey: ['useGetAllBrand', postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/brands/all`, postData);
      return data as BrandGetAllResponseT & { hasNextPage?: boolean };
    },
  });
};

export const useDelBrand = () => {
  return useMutation({
    mutationKey: ['useDelBrand'],
    mutationFn: async (brandId: string | undefined) => {
      const { data } = await axiosInstance.delete(`/brands/${brandId}`);
      return data;
    },
  });
};

export const useInfiniteGetAllBrand = (postData: PostDataT) => {
  return useInfiniteQuery({
    queryKey: [`useGetAllBrand`, postData],
    queryFn: async () => {
      const { data } = await axiosInstance.post(`/brands/all`, {
        ...postData,
      });
      return data as BrandGetAllResponseT & { hasNextPage?: boolean };
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.hasNextPage ? allPages.length + 1 : undefined;
      return nextPage;
    },
    initialPageParam: 1,
  });
};
